export default "__VITE_ASSET__DvztLKqy__"